import { BlogPost } from "@/types/blog";
import { Card, CardContent } from "@/components/ui/card";
import { Calendar, Clock, User, Trash2 } from "lucide-react"; // Import Trash2 icon
import { Button } from "@/components/ui/button"; // Import Button component

interface BlogCardProps {
  post: BlogPost;
  onClick: () => void;
  onDelete: (id: string) => void; // Add onDelete prop
}

export const BlogCard = ({ post, onClick, onDelete }: BlogCardProps) => {
  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent card's onClick from firing
    onDelete(post.id);
  };

  const publishDate = post.publishDate ? new Date(post.publishDate).toLocaleDateString() : 'N/A';

  return (
    <Card 
      className="group cursor-pointer overflow-hidden border-0 bg-card shadow-blog-card transition-all duration-300 hover:shadow-blog-card-hover hover:-translate-y-1 relative"
      onClick={onClick}
    >
      {post.image_url && (
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={post.image_url}
            alt={post.title}
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
        </div>
      )}
      <CardContent className="p-6">
        <h3 className="mb-3 text-xl font-bold leading-tight text-card-foreground group-hover:text-primary transition-colors">
          {post.title}
        </h3>
        
        <p className="mb-4 line-clamp-3 text-black leading-relaxed">
          {post.excerpt}
        </p>
        
        <div className="flex items-center justify-between text-sm text-muted-foreground">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1">
              <User className="h-4 w-4" />
              <span>{post.author}</span>
            </div>
            <div className="flex items-center gap-1">
              <Clock className="h-4 w-4" />
              <span>{post.readTime} min read</span>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <Calendar className="h-4 w-4" />
            <span>{publishDate}</span>
          </div>
        </div>
      </CardContent>
      <Button 
        variant="destructive" 
        size="sm" 
        className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity"
        onClick={handleDeleteClick}
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </Card>
  );
};